import { Button } from "@vernost_dev/vms-react-components/dist/Button";

const VmsButton = ({
  onClick,
  buttonType = "primary",
  disabled,
  isLoading,
  additionalClassName,
  additionalStyle,
  progress,
  isMobile,
  rippleEffect,
  children,
}) => {
  return (
    <Button
      onClick={onClick}
      buttonType={buttonType}
      disabled={disabled}
      isLoading={isLoading}
      additionalClassName={additionalClassName}
      additionalStyle={additionalStyle}
      progress={progress}
      isMobile={isMobile}
      rippleEffect={rippleEffect}
    >
      {children}
    </Button>
  );
};
export { VmsButton };
